import SystemtModule from '@/store/SystemModule'
import { getModule } from 'vuex-module-decorators'

const { user } = getModule(SystemtModule)
export default [
  {
    key: 'billing_month',
    label: 'Billing Month',
    sortable: true,
    show: true,
    thClass: 'align-middle text-center',
    class: 'align-middle',
  },
  {
    key: 'total_rows',
    label: 'Row Count',
    sortable: true,
    show: true,
    thClass: 'align-middle text-center',
    class: 'align-middle text-center',
  },
  {
    key: 'approval_progress',
    label: 'Approval Progress',
    sortable: true,
    show: true,
    thClass: 'align-middle text-center',
    class: 'align-middle text-center',
  },
  {
    key: 'status',
    label: 'Status',
    sortable: true,
    show: true,
    thClass: 'align-middle text-center',
    class: 'align-middle text-center',
  },
  {
    key: 'action',
    label: '',
    sortable: false,
    class: 'text-center align-middle',
    type: 'action_list',
    show: () => user && (user.can('publisher_reconciliation', 'view') || user.can('publisher_reconciliation', 'approve')),
    actions: [
      {
        icon: 'eye',
        title: 'View',
        event: 'view',
        show: () => user && user.can('publisher_reconciliation', 'view'),
      },

      {
        icon: 'check-double',
        title: 'Approve Month',
        event: 'approve_month',
        show: () => user && user.can('publisher_reconciliation', 'approve'),
      },

      {
        icon: 'check-square',
        title: 'Rematch',
        event: 'rematch',
        show: () => user && user.can('publisher_reconciliation', 'approve'),
      },
    ],
  },
]
